import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.experience-highlights__splide' ).each( function( index, element ) {
        new Splide( element, {
          type: 'loop',
          drag: false,
          perPage: 1,
          gap: '0',
          autoWidth: true,
          arrows: false,
          pagination: true,
        } ).mount();
      } );

      const cards = document.querySelectorAll( '.js-draw-border' );

      const observer = new IntersectionObserver(
          ( entries, obs ) => {
            const visibleEntries = entries.filter( ( entry ) => entry.isIntersecting );

            visibleEntries.forEach( ( entry, index ) => {
              const card = entry.target;

              setTimeout( () => {
                card.classList.add( 'is-visible' );
              }, index * 500 );

              obs.unobserve( card );
            } );
          },
          {
            threshold: 0.4,
          },
      );
      cards.forEach( ( card ) => observer.observe( card ) );
    },
  };
  app.registerComponent( 'experience-highlights', COMPONENT );
} )( app );
